import { Col, Row } from "antd";
import { InputStyle, labelStyle } from "../constants";
import SwitchOptionComponent from "../../../components/SwitchComponent";
import InputNumberComponent from "../../../components/InputNumberComponent";
import { SwitchContainer } from "./styles";
import InputComponent from "../../../components/InputComponent";
import SelectComponent from "../../../components/SelectComponent";
import { useDiscoveryContext } from "../../../context/DiscoveryContext/DiscoveryContext";
import { useEffect } from "react";


const Info = () => {
	const { discoveryData, setDiscoveryData, applicationData, getApplicationData } = useDiscoveryContext();

	const handleSelectChange = (value: string | undefined) => {
		setDiscoveryData({ ...discoveryData, applicationId: value });
	};

	useEffect(() => {
		getApplicationData()

	}, [])
	return (
		<>
			<Row gutter={20}>
				<Col span={6}>
					<InputNumberComponent
						title={"Sıra No"}
						placeholder=""
						isRequired
						style={InputStyle}
						value={discoveryData?.displayOrder}
						onChange={(value) => setDiscoveryData({ ...discoveryData, displayOrder: Number(value) })}
					/>
				</Col>
				<Col span={9}>
					<InputComponent
						title={"URL"}
						placeholder=""
						isRequired
						style={InputStyle}
						value={discoveryData?.targetUrl}
						onChange={(e) => setDiscoveryData({ ...discoveryData, targetUrl: e.target.value })}
					/>
				</Col>
			</Row >
			<Row gutter={20}>
				<Col span={6}>
					<SelectComponent
						title="Uygulama"
						isRequired
						value={discoveryData?.applicationId}
						style={{ marginBottom: "16px", width: "100%" }}
						options={applicationData}
						onChange={handleSelectChange}
					/>
				</Col>
				<Col span={6}>
					<SwitchContainer>
						<SwitchOptionComponent
							key={"isActive"}
							title={"Görünürlük"}
							labelStyle={labelStyle}
							value={discoveryData?.isVisible}
							onChange={(checked) => setDiscoveryData({ ...discoveryData, isVisible: checked })}
						/>
					</SwitchContainer>
				</Col>
			</Row>
		</>
	);
};

export default Info;
